import { render } from "./ftaDisposition.vue?vue&type=template&id=492a808e"
import script from "./ftaDisposition.vue?vue&type=script&lang=js"
export * from "./ftaDisposition.vue?vue&type=script&lang=js"

import "./ftaDisposition.vue?vue&type=style&index=0&id=492a808e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__